import { Panel, StorageKeys } from "@validereinc/common-components";
import React from "react";
import { EmissionsHomeMetricTileXYChart } from "./EmissionsHomeMetricTileXYChart";

export const TotalEmissionsPanel = ({
  viewConfigStorageKey,
}: Pick<StorageKeys, "viewConfigStorageKey">) => {
  return (
    <Panel
      title="Total Emissions"
      style={{ marginBottom: 0 }}
    >
      <EmissionsHomeMetricTileXYChart
        viewConfigStorageKey={viewConfigStorageKey}
      />
    </Panel>
  );
};
